import React from 'react';
import { ShoppingBag, Download, Star, Cpu, Brain, Mic } from 'lucide-react';

const items = [
  { id: 1, name: 'Koolaber Blend v2', type: 'Model Pack', price: 0, rating: 4.8, downloads: 1253, desc: 'Optimized routing blend for cost-efficient AI' },
  { id: 2, name: 'Piper TTS - Portuguese', type: 'Voice Pack', price: 0, rating: 4.6, downloads: 847, desc: 'High-quality Portuguese TTS voice model' },
  { id: 3, name: 'Speaker Diarization', type: 'Tool', price: 0, rating: 4.3, downloads: 521, desc: 'Identify who speaks when in audio' },
  { id: 4, name: 'Custom Agent Template', type: 'Blueprint', price: 0, rating: 4.9, downloads: 2104, desc: 'Production-ready sovereign agent template' },
];

function MarketplaceSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Marketplace</h2>
        <p className="text-slate-400 mt-1">Models, tools, and blueprints for your stack</p>
      </div>

      <div className="glass-panel divide-y divide-slate-800/50">
        <div className="p-6">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Featured Items</h3>
        </div>
        {items.map((item) => (
          <div key={item.id} className="p-5 hover:bg-slate-800/30 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-purple-600/20 flex items-center justify-center">
                  <ShoppingBag className="w-5 h-5 text-purple-400" />
                </div>
                <div>
                  <p className="text-white font-semibold">{item.name}</p>
                  <p className="text-xs text-slate-500">{item.desc}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <div className="flex items-center gap-1 text-xs text-amber-400">
                    <Star className="w-3 h-3 fill-amber-400" /> {item.rating}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-slate-500">
                    <Download className="w-3 h-3" /> {item.downloads}
                  </div>
                </div>
                <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-emerald-600/20 text-emerald-400">
                  FREE
                </span>
                <button className="text-xs font-medium px-3 py-1.5 rounded-lg bg-purple-600/20 text-purple-400 hover:bg-purple-600/30 transition-colors">
                  Install
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MarketplaceSection;
